import { render, staticRenderFns } from "./CadastroServicos.vue?vue&type=template&id=14740a92&scoped=true&"
import script from "./CadastroServicos.vue?vue&type=script&setup=true&lang=js&"
export * from "./CadastroServicos.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14740a92",
  null
  
)

export default component.exports